import { isBooleanTrue } from './objectUtils';

// every role a login carries as a claim beside the same flag on its profile. createRoleClaims sends all of them and
// revokes any it is not given, so a role added here reaches every save that builds its flags through toRoleFlags
export const ROLE_FLAGS = ['isRep', 'isAdmin', 'isSuperAdmin', 'isCoveredEntityUser', 'isAffiliateUser', 'isPartnerUser', 'isHelpStaff', 'isStaffManager', 'isMarketingManager', 'isOwner', 'isDesigner'];

// each role named, true or false, from anything that carries them - a profile, a form's values or a login's claims
export const toRoleFlags = (source) => Object.fromEntries(ROLE_FLAGS.map((role) => [role, isBooleanTrue(source?.[role])]));
